// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {MultiDropdownInput} from '@supermove/components';
import {useResponsive, useState, Form} from '@supermove/hooks';
import {ViewStyleProp} from '@supermove/styles/types';

// App
import FieldInput from '@shared/design/components/Field/FieldInput';

const getDropdownOptions = <T,>({
  form,
  field,
  inputText,
}: {
  form: Form<T>;
  field: string;
  inputText: string;
}) => {
  const entries = _.get(form.values, field).map((entry: string) => ({
    label: entry,
    value: entry,
  }));

  return inputText ? [...entries, {label: inputText, value: inputText}] : entries;
};

const MultiEntryFieldInput = <T,>({
  form,
  field,
  index = 0,
  label,
  tooltip,
  placeholder,
  inputStyle = {flex: 1},
  containerStyle = {width: '100%'},
}: {
  form: Form<T>;
  field: string;
  index?: number;
  label: string;
  tooltip?: string;
  placeholder?: string;
  inputStyle?: React.CSSProperties;
  containerStyle?: ViewStyleProp;
}) => {
  const responsive = useResponsive();
  const [inputText, setInputText] = useState<string>('');

  return (
    <FieldInput
      {...form}
      index={index}
      isResponsive
      component={MultiDropdownInput}
      name={field}
      label={label}
      tooltip={tooltip}
      input={{
        options: getDropdownOptions({form, field, inputText}),
        placeholder,
        setFieldValue: form.setFieldValue,
        isSearchable: true,
        onChangeValue: (values: string[]) => {
          form.setFieldValue(field, values);
        },
        onInputChange: (value: string) => {
          setInputText(value);
        },
        onBlur: () => {
          const inputTextTrimmed = inputText.trim();
          if (inputTextTrimmed) {
            const entries = _.get(form.values, field);
            form.setFieldValue(field, [...entries, inputText]);
          }
          setInputText('');
        },
        components: {
          Menu: () => null,
          DropdownIndicator: () => null,
        },
        style: inputStyle,
        isMobile: !responsive.desktop,
      }}
      style={containerStyle}
    />
  );
};

export default MultiEntryFieldInput;
